import "./Header.scss";

const Header = () => {
  return (
    <div className="header">
      <span className="text-shadow">What is your Horoscope?</span>
    </div>
  )
}

export default Header
